import React from "react";
import ChatTooltip from "./components/ChatTooltip";

interface IProps {
  setClickOutsideActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const Chat = (props: IProps) => {
  return (
    <>
      <ChatTooltip {...props} />
    </>
  );
};

export default Chat;
